// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"189":"fundDetail","335":"deposit","483":"betRecord","533":"withdraw","594":"about","773":"gamePanel","790":"transferOut","979":"transferIn"}[chunkId] + "." + {"189":"fbdf9417","335":"b9eb4d16","483":"3cf5eecd","533":"eaf7d205","594":"1caa25d6","773":"c6fd9502","790":"95735109","979":"efdd978d"}[chunkId] + ".js";
};